export default __webpack_public_path__ + "static/media/Coronal Leggings.57c03eab.jpg";